import cx from "classnames";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
const Input = ({
    id,
    className,
    disabled,
    placeholder,
    input,
    meta,
    value,
    onChange = null,
    autoComplete,
    type = "text",
    setShowPassword,
    showPassword
}) => (
    <div className="relative">
        <input
            {...input}
            autoComplete={autoComplete}
            value={input ? input.value : value}
            disabled={disabled}
            id={id}
            type={(input &&  input.type) ? input.type=="password"&& showPassword==true?"text":input.type : type}
            className={cx(
                "block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm",
                "group-[.has-error]:input-error",
                {
                    className: className,
                    "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200": disabled,
                    "w-[88%]":input?.type=="password"
                }
            )}
            placeholder={placeholder}
            onChange={(e) => {
                onChange && onChange(e);

                return input ? input.onChange(e) : null;
            }}
        />
        <span className={`absolute items-center justify-center w-[50px] h-full rounded-r-lg inset-y-0 right-0 ${input?.type=="password"? "flex": "hidden" } ${showPassword?"bg-orange-500":"bg-gray-500"}`}
        onClick={(e)=>{
            e.preventDefault();
            e.stopPropagation();
            setShowPassword&&setShowPassword()
            }}>
            <i className={`fa-regular  text-lg text-white far ${showPassword?"fa-eye":"fa-eye-slash"}`}></i>
        </span>
        <div className={`pointer-events-none absolute inset-y-0 ${input?.type=="password"? "right-12": "right-0" } hidden items-center pr-3 group-[.has-error]:flex`}>
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
        </div>
    </div>
);
export default Input;
